// import { GETALLELECTIONTYPE } from "../actions/type";

// const initialState = {
//   electiontypeList: [],
// };

// export default function (state = initialState, action) {
//   switch (action.type) {
//     case GETALLELECTIONTYPE:
//       return {
//         ...state,
//         electiontypeList: action.payload.data || action.payload,
//       };
//     default:
//       return state;
//   }
// }
import {
  GETALLELECTIONTYPE,
  CREATEELECTIONTYPE,
  UPDATEELECTIONTYPE,
  DELETEELECTIONTYPE,
} from "../actions/type";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    // Setup partyTypeList Cases
    case GETALLELECTIONTYPE:
      return {
        ...state,
        electiontypeList: action.payload.data,
      };
    case CREATEELECTIONTYPE:
      return {
        ...state,
        createelectiontypeList: action.payload.success,
      };
    case UPDATEELECTIONTYPE:
      return {
        ...state,
        updateelectiontypeList: action.payload.success,
      };
    case DELETEELECTIONTYPE:
      return {
        ...state,
        deleteelectiontypeList: action.payload.success,
      };

    default:
      return state;
  }
}
